import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

@Injectable()
export class LogService {

  constructor() { }

  error(module = 'oregano', operation = 'operation', message = 'unknown error occured') {
    console.error(`${module}.${operation} failed: ${message}`);
  }

  log(module: string, message: string) {
    console.log(`${module}: ${message}`);
  }
}
